/* import __COLOCATED_TEMPLATE__ from './carousel.hbs'; */
var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { assert } from '@ember/debug';
import { computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';

// TODO(steckel): Consider pushing up to a shared location.
let Carousel = (_dec = computed('index', 'width', 'items.[]'), _dec2 = computed('height', 'width'), _class = class Carousel extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "height", void 0);
    _initializerDefineProperty(this, "index", _descriptor, this);
    _defineProperty(this, "items", void 0);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "width", void 0);
  }
  didReceiveAttrs() {
    super.didReceiveAttrs();
    assert('index attribute must be within bounds of 0 and items.length', this.index >= 0 && this.index < this.items.length);
  }
  get carouselContentStyle() {
    const x = `${this.width * this.index * -1}px`;
    const transform = `transform: translate3d(${x}, 0, 0);`;
    const width = `width: ${this.width * this.items.length}px;`;
    return htmlSafe([transform, width].join(' '));
  }
  get widthAndHeightStyle() {
    return htmlSafe(`width: ${this.width}px; height: ${this.height}px`);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "index", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "carouselContentStyle", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "carouselContentStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "widthAndHeightStyle", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "widthAndHeightStyle"), _class.prototype), _class);
export { Carousel as default };